<template>
    <div>
        <div class="row">
            <div class="col-lg-3">
                <div class="form-group mb-4">
                    <label for="collection_start">
                        <strong>
                            Collection Dates
                        </strong>
                    </label>
                    <div class="input-daterange input-group">
                        <input v-model="filters.collectionDateFrom"
                               class="input-sm form-control js-date-picker "
                               name="collection_start"
                               value=""
                               type="text"
                        >
                        <span class="input-group-addon">to</span>
                        <input v-model="filters.collectionDateTo"
                               class="input-sm form-control js-date-picker"
                               name="collection_end"
                               value=""
                               type="text"
                        >
                    </div>
                </div>
                <div class="form-group mb-4">
                    <label>
                        <strong>
                            Delivery Dates
                        </strong>
                    </label>
                    <div class="input-daterange input-group">
                        <input v-model="filters.deliveryDateFrom"
                               class="input-sm form-control js-date-picker"
                               name="delivery_start"
                               value=""
                               type="text"
                        >
                        <span class="input-group-addon">to</span>
                        <input v-model="filters.deliveryDateTo"
                               class="input-sm form-control js-date-picker"
                               name="delivery_end"
                               value=""
                               type="text"
                        >
                    </div>
                </div>
            </div>
            <div class="col-lg-3" v-if="!hide.includes('customer')">
                <CustomerSelect
                    v-model="filters.selectedCustomer"
                    :errors="errors ? errors : []"
                />
            </div>
            <div class="col-lg-3" v-if="!hide.includes('drivers')">
                <!-- this component doesn't clear properly -->
                <DriverSelect
                    :errors="[]"
                    @update-driver="updateSelectedDriver"
                />
            </div>
            <div class="col-lg-6">
                <label>
                    <strong>
                        Status
                    </strong>
                </label>
                <div class="row">
                    <div class="col-lg-4">
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-signed-off" title="Admin satisfied with Job, ready for Invoice">
                                <input v-model="filters.status" class="me-1" id="checkbox-signed-off" type="checkbox" name="status[]" value="signed-off" />
                                Signed Off
                            </label>
                        </div>
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-ready-to-invoice" title="All Movements completed, Job Ready to Invoice">
                                <input v-model="filters.status" class="me-1" id="checkbox-ready-to-invoice" type="checkbox" name="status[]" value="ready-to-invoice" />
                                Ready to Invoice
                            </label>
                        </div>
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-completed" title="All Movements completed, Job finished">
                                <input v-model="filters.status" class="me-1" id="checkbox-completed" type="checkbox" name="status[]" value="completed" />
                                Completed
                            </label>
                        </div>
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-in-progress" title="Movements started, not all Movements finished">
                                <input v-model="filters.status" class="me-1" id="checkbox-in-progress" type="checkbox" name="status[]" value="in-progress" />
                                In Progress
                            </label>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-assigned" title="All Movements assigned, none started">
                                <input v-model="filters.status" class="me-1" id="checkbox-assigned" type="checkbox" name="status[]" value="assigned" />
                                All Assigned
                            </label>
                        </div>
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-accepted" title="Job accepted, ready for Movement assignment">
                                <input v-model="filters.status" class="me-1" id="checkbox-accepted" type="checkbox" name="status[]" value="accepted" />
                                Accepted
                            </label>
                        </div>
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-closed" title="Job invoiced to Customer">
                                <input v-model="filters.status" class="me-1" id="checkbox-closed" type="checkbox" name="status[]" value="closed" />
                                Closed
                            </label>
                        </div>
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-aborted" title="Driver travelled to collect Vehicle, Vehicle not able to be moved">
                                <input v-model="filters.status" class="me-1" id="checkbox-aborted" type="checkbox" name="status[]" value="aborted" />
                                Aborted
                            </label>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-part-assigned" title="Some Movements assigned, some outstanding">
                                <input v-model="filters.status" class="me-1" id="checkbox-part-assigned" type="checkbox" name="status[]" value="part-assigned" />
                                Part Assigned
                            </label>
                        </div>
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-pending-acceptance" title="Job created by Customer, not able to be assigned">
                                <input v-model="filters.status" class="me-1" id="checkbox-pending-acceptance" type="checkbox" name="status[]" value="pending-acceptance"/>
                                Pending Acceptance
                            </label>
                        </div>
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-pending-review" title="Job awaiting approval from Customer">
                                <input v-model="filters.status" class="me-1" id="checkbox-pending-review" type="checkbox" name="status[]" value="pending-review"/>
                                Pending Review
                            </label>
                        </div>
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-missing-required-po" title="Job is missing required PO">
                                <input v-model="filters.status" class="me-1" id="checkbox-missing-required-po" type="checkbox" name="status[]" value="missing-required-po"/>
                                Missing Required PO
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <!-- The id is depended on by BulkUpdate.vue and by main.scss; without it the bulk
                 panels never appear, because their draw listener is never attached. -->
            <table id="datatable-jobs-list" ref="jobsTable" class="table table-bordered table-striped table-vcenter dataTable" style="width: 100%;">
                <thead>
                    <tr>
                        <th v-if="!hide.includes('select')" class="text-center">
                            <input type="checkbox" id="checkAll" />
                        </th>
                        <th v-if="!hide.includes('reference')">Job Ref.</th>
                        <th v-if="!hide.includes('status')">Status</th>
                        <th v-if="!hide.includes('contract')">Contract</th>
                        <th v-if="!hide.includes('customer')">Customer</th>
                        <th v-if="!hide.includes('drivers')">Drivers</th>
                        <th v-if="!hide.includes('clientRef')">Purchase Order (Client Ref.)</th>
                        <th v-if="!hide.includes('collectionDate')">Collection Date</th>
                        <th v-if="!hide.includes('deliveryDate')">Delivery Date</th>
                        <th v-if="!hide.includes('journey')">Journey</th>
                        <th v-if="!hide.includes('vehicle')">Vehicle</th>
                        <th v-if="!hide.includes('actions')">Actions</th>
                    </tr>
                </thead>
                <tbody></tbody>
            </table>
        </div>

        <div v-if="!hide.includes('select')" class="d-flex flex-wrap mt-3">
            <div class="w-100">
                <p class="mb-2">
                    <strong>Bulk Actions:</strong>
                </p>
                <p class="mb-2">
                    If there are items selected using the checkboxes, these actions will be performed on the selected items only.
                </p>
                <p class="mb-2">
                    If there are no items selected using the checkboxes, these actions will be performed on all items currently shown in the table (i.e. after filtering).
                </p>
            </div>

            <div class="d-flex align-items-center mb-2 w-100">
                <ul class="selectedList list-inline mb-2">
                    <li v-if="selectedJobs.length > 0" class="list-inline-item"><strong>Checked:</strong></li>
                    <li v-for="job in selectedJobs" :key="job.id" class="list-inline-item">
                        <span class="badge bg-primary">{{ job.reference || job.id }}</span>
                    </li>
                    <li v-if="selectedJobs.length > 0" class="list-inline-item">
                        <a href="#" @click.prevent="selectedJobs = []">Clear?</a>
                    </li>
                </ul>
            </div>

            <div>
                <button class="btn btn-danger btn-sm" type="button" :disabled="isSendingPoReminder" @click="submitEmailPoReminder">
                    <i class="fa fa-envelope me-1"></i>
                    {{ isSendingPoReminder ? 'Sending...' : 'Email PO Reminder' }}
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, reactive, onBeforeUnmount, onMounted, watch } from 'vue';
import { buildColumns } from "@/helpers/build-columns";
import { bindSelectAll } from "@/helpers/bulk-select";
import CustomerSelect from '@/components/movements/components/CustomerSelect.vue';
import DriverSelect from '@/components/movements/components/DriverSelect.vue';
import flatpickr from 'flatpickr';
import axios from 'axios';
import Swal from 'sweetalert2';

const props = defineProps({
    ajaxUrl: {
        type: String,
        required: true,
    },
    filter: {
        type: String,
        required: false
    },
    hide: {
        type: Array,
        default: () => [],
        required: false
    },
    orderBy: {
        type: Array,
        default: [[6, 'desc']]
    },
    old: {
        type: String,
        required: false
    },
    errors: {
        type: Array,
        default: () => [],
        required: false
    },
});

const columnDefinitions = reactive({
    select: {
        data: 'id',
        orderable: false,
        searchable: false,
        width: '70px',
        render: function (data, type, row) {
            return row.computed_select;
        },
    },
    reference: {
        data: 'id',
        render: function (data, type, row) {
            return row.computed_reference;
        }
    },
    status: {
        data: 'status',
        searchable: false,
    },
    contract: {
        data: 'contract.name',
        searchable: false,
        render: function (data, type, row) {
            return row.computed_contract;
        }
    },
    customer: {
        name: 'customer.name',
        render: function (data, type, row) {
            return row.computed_customer;
        }
    },
    drivers: {
        searchable: false,
        orderable: false,
        render: function (data, type, row) {
            return row.computed_drivers;
        }
    },
    clientRef: {
        data: 'client_ref',
        searchable: false,
    },
    collectionDate: {
        data: 'collection_date',
        width: '200px',
        render: function (data, type, row) {
            return row.computed_collection_date;
        }
    },
    deliveryDate: {
        name: 'delivery_date',
        width: '200px',
        render: function (data, type, row) {
            return row.computed_delivery_date;
        }
    },
    journey: {
        searchable: false,
        orderable: false,
        width: '200px',
        render: function (data, type, row) {
            return row.collection_locale + '<br> to ' + row.delivery_locale;
        },
    },
    vehicle: {
        searchable: false,
        orderable: false,
        render: function (data, type, row) {
            return row.computed_vehicle;
        }
    },
    actions: {
        name: 'actions',
        data: 'actions',
        searchable: false,
        orderable: false,
        width: '200px',
    }
});

const filters = reactive({
    invoiceDateFrom: null,
    invoiceDateTo: null,
    collectionDateFrom: null,
    collectionDateTo: null,
    deliveryDateFrom: null,
    deliveryDateTo: null,
    status: [
        'signed-off',
        'completed',
        'in-progress',
        'assigned',
        'accepted',
        'closed',
        'aborted',
        'part-assigned',
        'pending-acceptance',
        'pending-review',
        'ready-to-invoice',
    ],
    selectedCustomer: null,
    selectedDriver: null,
});

const jobsTable = ref(null);
const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? '';
const selectedJobs = ref([]);
const isSendingPoReminder = ref(false);

const generateEmailPoReminderRoute = () => route('api.movements.jobs.bulk.email-po-reminder');

const normaliseCount = (value) => {
    const parsed = Number(value);

    if (!Number.isFinite(parsed)) {
        return null;
    }

    return parsed;
};

const buildPoReminderPayload = () => {
    const payload = { _token: csrfToken, filters };

    if (selectedJobs.value.length > 0) {
        payload.job_ids = selectedJobs.value.map((job) => job.id);
    }

    try {
        const ajaxUrl = new URL(props.ajaxUrl, window.location.origin);
        ['customer', 'address'].forEach(key => {
            const val = ajaxUrl.searchParams.get(key);
            if (val) payload[key] = Number(val);
        });
    } catch (_e) {}

    return payload;
};

const buildPoReminderReportRowsHtml = (data = {}) => {
    return ['Requested', 'Eligible', 'Skipped', 'Sent']
        .map(label => {
            const key = label.toLowerCase();
            const val = normaliseCount(data[key]) ?? '-';
            return `<tr><th class="text-start pe-4" style="border: 0; padding: 0.25rem 0; vertical-align: top;">${label}</th><td class="text-start" style="border: 0; padding: 0.25rem 0;">${val}</td></tr>`;
        }).join('');
};

const showPoReminderConfirmationModal = async (data = {}) => {
    const eligible = normaliseCount(data.eligible) ?? 0;
    const reportRowsHtml = buildPoReminderReportRowsHtml({ ...data, sent: eligible });

    return Swal.fire({
        icon: eligible > 0 ? 'warning' : 'info',
        title: 'Are you sure?',
        width: '34rem',
        html: `<p class="mb-3 text-center">${data.message ?? 'Please confirm before sending PO reminder emails.'}</p>
               <p class="mb-3 text-center"><strong>${eligible}</strong> user${eligible === 1 ? '' : 's'} will be emailed.</p>
               <table style="width: 100%; max-width:320px; border-collapse: collapse; margin:0 auto 1rem auto;">${reportRowsHtml}</table>`,
        confirmButtonText: eligible > 0 ? 'Yes, send emails' : 'Continue',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        reverseButtons: true,
    });
};

const showEmailPoReminderResultModal = (data = {}) => {
    const isSuccess = String(data.status).toLowerCase() === 'success' && data.sent !== 0;
    const warningHtml = normaliseCount(data.sent) === 0 ? '<p class="text-warning mb-0 mt-3"><strong>no emails were sent this time</strong></p>' : '';

    Swal.fire({
        icon: isSuccess ? 'success' : 'warning',
        title: data.message ?? (isSuccess ? 'PO reminder emails successfully sent' : 'PO reminder request completed'),
        width: '30rem',
        html: `<table style="width: 100%; max-width:310px; border-collapse: collapse; margin:0 auto 1rem auto;">${buildPoReminderReportRowsHtml(data)}</table>${warningHtml}`,
        confirmButtonText: 'Close',
    });
};

const submitEmailPoReminder = async () => {
    if (isSendingPoReminder.value) {
        return;
    }

    isSendingPoReminder.value = true;
    const payload = buildPoReminderPayload();

    try {
        const previewResponse = await axios.post(generateEmailPoReminderRoute(), {
            ...payload,
            dry_run: true,
        }, {
            headers: {
                Accept: 'application/json',
            },
        });

        const confirmResult = await showPoReminderConfirmationModal(previewResponse?.data);

        if (!confirmResult.isConfirmed) {
            return;
        }

        const response = await axios.post(generateEmailPoReminderRoute(), payload, {
            headers: {
                Accept: 'application/json',
            },
        });

        showEmailPoReminderResultModal(response?.data);
    } catch (error) {
        showEmailPoReminderResultModal(
            error?.response?.data ?? {
                message: 'Unable to send PO reminders. Please try again.',
            }
        );
    } finally {
        isSendingPoReminder.value = false;
    }
};

let tableElementJq = null;
let tableInstance = null;
const getTableElement = () => {
    if (tableElementJq && tableElementJq.length) {
        return tableElementJq;
    }

    if (!jobsTable.value) {
        return null;
    }

    tableElementJq = window.jQuery(jobsTable.value);

    return tableElementJq;
};

const getJobSelectionFromCheckbox = (checkbox) => {
    if (!checkbox) {
        return null;
    }

    try {
        const parsedValue = JSON.parse(checkbox.value);
        const jobId = parsedValue?.id ?? null;

        if (jobId === null) {
            return null;
        }

        return {
            id: jobId,
            reference: parsedValue?.ref ?? null,
        };
    } catch (_error) {
        return null;
    }
};

const isJobSelected = (jobId) => selectedJobs.value.some((job) => job.id === jobId);

const setJobSelection = (job, shouldSelect) => {
    const jobId = job?.id;

    if (jobId === null || jobId === undefined) {
        return;
    }

    if (shouldSelect) {
        if (!isJobSelected(jobId)) {
            selectedJobs.value = [
                ...selectedJobs.value,
                {
                    id: jobId,
                    reference: job?.reference ?? null,
                },
            ];
        }

        return;
    }

    selectedJobs.value = selectedJobs.value.filter((selectedJob) => selectedJob.id !== jobId);
};

const syncSelectAllCheckbox = () => {
    const tableElement = getTableElement();

    if (!tableElement || !tableElement.length) {
        return;
    }

    const selectAll = tableElement.find('#checkAll').get(0);

    if (!selectAll) {
        return;
    }

    const checkboxes = tableElement.find('.bulk-update-checkbox');
    const checkedCount = checkboxes.filter(':checked').length;
    const total = checkboxes.length;

    selectAll.indeterminate = checkedCount > 0 && checkedCount < total;
    selectAll.checked = total > 0 && checkedCount === total;
};

const syncCheckboxesWithState = (checkboxes) => {
    checkboxes.each((_, element) => {
        const checkbox = element;
        const job = getJobSelectionFromCheckbox(checkbox);
        const jobId = job?.id ?? null;
        checkbox.checked = jobId !== null && isJobSelected(jobId);
    });

    syncSelectAllCheckbox();
};

const handleDraw = () => {
    const tableElement = getTableElement();
    if (!tableElement?.length) return;

    const checkboxes = tableElement.find('.bulk-update-checkbox');

    syncCheckboxesWithState(checkboxes);

    checkboxes.off('change.jobSelect').on('change.jobSelect', (e) => {
        setJobSelection(getJobSelectionFromCheckbox(e.currentTarget), e.currentTarget.checked);
        syncSelectAllCheckbox();
    });

};
const updateSelectedDriver = (value) => {
    filters.selectedDriver = value ?? null;
};

onMounted(() => {
    if (props.filter) filters.status = [props.filter];
    const table = getTableElement();
    if (!table?.length) return;

    table.on('preXhr.dt', (e, settings, data) => { data.filters = filters; })
        .DataTable({
            processing: true,
            serverSide: true,
            pageLength: 25,
            lengthMenu: [25, 50, 100],
            ajax: { url: props.ajaxUrl },
            order: props.orderBy,
            columns: buildColumns(columnDefinitions, props.hide),
        });

    tableInstance = table.DataTable();
    flatpickr('.js-date-picker', { altInput: true, altFormat: 'F j, Y', dateFormat: 'Y-m-d' });

    watch(filters, () => tableInstance.ajax.reload(null, false), { deep: true });
    tableInstance.on('draw', handleDraw);
    handleDraw();

    // The shared helper owns the master checkbox and dispatches row changes,
    // keeping selectedJobs in sync with the visible selection.
    bindSelectAll({
        tableSelector: '#datatable-jobs-list',
        masterSelector: '#checkAll',
    });
});

watch(selectedJobs, () => {
    const checkboxes = getTableElement()?.find('.bulk-update-checkbox');
    if (checkboxes) syncCheckboxesWithState(checkboxes);
});
</script>
